module.exports = "/work-site/img/leave1.2db1901d.png";